import { render } from "./ComingSoonCardAndNotification.vue?vue&type=template&id=a33521cc"
import script from "./ComingSoonCardAndNotification.vue?vue&type=script&lang=js"
export * from "./ComingSoonCardAndNotification.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__